import slice from "./competitionSlice";

export default slice.reducer;
